import { Outlet, createFileRoute } from "@tanstack/react-router";

import { AGENT_ROLES, AuthGuard } from "@/lib/auth";

export const Route = createFileRoute("/_authenticated/admin")({
	component: AdminLayout,
});

function AdminLayout() {
	return (
		<AuthGuard requiredRole={AGENT_ROLES.SUPPORT_ADMIN}>
			<Outlet />
		</AuthGuard>
	);
}
